import { render, staticRenderFns } from "./MyReturnsNew.vue?vue&type=template&id=6ad2f2d1&"
import script from "./MyReturnsNew.vue?vue&type=script&lang=js&"
export * from "./MyReturnsNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports